import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { RadioButton } from 'react-native-paper';

import type { PostFeedTypeFeature } from '@/features/feature-management/types/postTypeFeature';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { resolveChannelLabel } from '@/features/post-editor/utils/resolveChannelLabel';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { POST_FEED_TYPE_ICONS } from '@/features/posts/utils/postFeed';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  selected?: PostFeedType;
  channels: PostFeedTypeFeature[];
  isOrganization?: boolean;
  onSelect: (value: PostFeedType) => void;
};

export const PostTypeSelectionView: FC<Props> = ({
  selected = PostFeedType.GOSSIP,
  channels,
  isOrganization = false,
  onSelect
}) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.POST_CREATION, {
    keyPrefix: 'screens.post-editor'
  });
  return (
    <ListSection
      headerBackgroundColor="transparent"
      style={{ marginVertical: 0 }}
    >
      {channels.map((channel) => (
        <ListItem
          key={channel.type}
          testID={`post-creation-channel-${channel.type}`}
          title={resolveChannelLabel(
            channel.type,
            channel.channelName,
            isOrganization,
            t
          )}
          onPress={() => onSelect?.(channel.type)}
          icon={() =>
            POST_FEED_TYPE_ICONS[channel.type]({
              fill: theme.colors.onSurface,
              height: 24,
              width: 24
            }) ?? <></>
          }
          style={{ paddingVertical: 6 }}
          backgroundColor={theme.colors.surfaceContainerLow}
          arrowIcon={() => (
            <View style={{ margin: -8 }}>
              <RadioButton
                onPress={() => onSelect?.(channel.type)}
                value={channel.type}
                status={selected === channel.type ? 'checked' : 'unchecked'}
              />
            </View>
          )}
        />
      ))}
    </ListSection>
  );
};
